import $ from 'jquery';
import ElementUI from 'element-ui';
import Vue from 'vue';

function myfun() {

}
function warnMessage2(obj) {
    this.$alert(obj, '温馨提示', {
        confirmButtonText: '确定',
    });
}
export { //很关键
    myfun,warnMessage2
}